<template>
  <!-- <pre>
  {{brand_product_styles}}
  </pre>

  <pre>
    {{ new_style_variables }}
  </pre> -->

  <div
    v-show="styles_loaded"
    :class="setbrandid"
    :style="new_style_variables"
    v-cloak
  >
    <Header
      :key="updateHeader"
      :logo_link="logo_link"
      :home_link="home_link"
      :header_menu="header_menu"
      :show_basket="show_basket"
      :show_home="true"
      :show_languages="true"
      :basket_number="0"
      :logo_image="logo_image"
      :lang="lang.toUpperCase()"
      :translations="translations"
      :brandSlug="setbrandid"
      :highlight_tab_item="1"
      :basket_is_model="true"
      :popup_page="'index'"
    ></Header>

    <div id="main" role="main" class="page-bg" :style="set_style_variables" v-if="brandloaded">
      <!-- <Basket
      :passedclass="``"
      :positionTop="`24px`"
      :position="`fixed`"
      :showButton="true"
      :lang="`EN`"
      :key="basketKey"
      :hasItems="true"
      :totalfee="100"
      :bookingfee="0"
    ></Basket> -->

      <!-- <pre>
        {{this.fetch_images}}
      </pre> -->


      <template v-if="setbrandid === 'CP1'">
        <div class="hero-section-middle-split">
          <div class="hero-section-middle-split-grid">
            <!-- SB2 St. Pancras International - SB2 -->
            <div class="hero-section">
              <div class="hero-text">
                <h1>{{ getrans("Belfast International Parking.") }}</h1>
                <p>{{ getrans("Parking that saves you money.") }}</p>
              </div>
            </div>
            <div class="hero-widget-container">
               <SearchWidget
                v-if="setbrandid"
                :brand_slug="setbrandid"
                showTabs="parking"
                :activeTab="'parking'"
                :lang="lang"
                custom_class="dark-mobile"
                fetch_images="false"
                hideTabs="true"
                :multi_book="multi_book ? 'true' : ''"
              />
            </div>
          </div>
        </div>
      </template>

      <template v-else>

      <div class="hero-section" v-if="!hero_middle_split()">
        <div
          v-if="setbrandid === 'BHX'"
          class="hero-bg-desktop"
          :style="`background-image: url(${this.hero_desktop_background}); transition: all 0s ease;`"
        ></div>
        <template v-for="hero in this.fetch_images" :key="hero">
          <div
            v-if="setbrandid !== 'BHX'"
            class="hero-bg-desktop"
            :style="`opacity: ${
              hero === this.hero_desktop_background ? '1' : '0'
            }; background-image: url(${hero}); transition: opacity ${fade_transition}s ease;`"
          ></div>
        </template>

        <div class="hero-overlay"></div>

        <div class="hero-bg-mobile">
          <!-- this shows on both desktop and mobile -->

          <template v-if="setbrandid === 'OKC'">
            <div class="hero-text subheading-alt">
              <h1>{{ getrans(banner_heading) || "" }}</h1>
              <span>{{ getrans(banner_subheading) || "" }}</span> <br />
              <span>
                {{ "Official Airport Parking" }}
              </span>
            </div>
          </template>
          <template v-else-if="setbrandid === 'LAX'">
            <div class="hero-text subheading-alt">
              <h1>
                {{
                  getrans("Welcome to Los Angeles International Airport") || ""
                }}
              </h1>
              <h1>{{ getrans("OFFICIAL AIRPORT PARKING") || "" }}</h1>
              <span>{{
                getrans(
                  "It's good to see you today! Ready to make a booking?"
                ) || ""
              }}</span>
            </div>
          </template>
          <template v-else>
            <div class="hero-text">
              <div v-if="setbrandid == 'PIT'" class="PITBorder"></div>
              <h1>{{ getrans(banner_heading) || "" }}</h1>
              <p>{{ getrans(banner_subheading) || "" }}</p>
            </div>
          </template>
        </div>
        <div class="search-widget-desktop" v-if="!widget_below_hero()">
          <SearchWidget
            v-if="tab_param && setbrandid && setbrandid === 'FM1'"
            :brand_slug="setbrandid"
            showTabs="parking, lounge, fasttrack, coach, travel, flights, holidays, hotels, tours"
            :activeTab="'tours'"
            :lang="lang"
            custom_class="dark-mobile"
            fetch_images="true"
          />
          <SearchWidget
            v-else-if="tab_param && setbrandid && setbrandid === 'FMM'"
            :brand_slug="setbrandid"
            showTabs="parking, lounge, fasttrack, flights"
            :activeTab="'parking'"
            :lang="lang"
            custom_class="dark-mobile"
            fetch_images="true"
          />
          <SearchWidget
            v-else-if="tab_param && setbrandid && setbrandid === 'PV1'"
            :brand_slug="setbrandid"
            showTabs="parking"
            :activeTab="'parking'"
            :lang="lang"
            custom_class="dark-mobile"
            fetch_images="true"
            hide-tabs="true"
          />
          <!-- <SearchWidget
            v-else-if="tab_param && setbrandid && setbrandid === 'JER'"
            :brand_slug="setbrandid"
            showTabs="parking, fasttrack"
            :activeTab="'parking'"
            :lang="lang"
            custom_class="dark-mobile"
            fetch_images="true"
            hide-tabs="false"
          /> -->
          <SearchWidget
            v-else-if="tab_param && setbrandid && setbrandid === 'PIT'"
            :brand_slug="setbrandid"
            showTabs="parking, lounge, fasttrack"
            :activeTab="'parking'"
            :lang="lang"
            custom_class="dark-mobile"
            fetch_images="true"
          />
          <SearchWidget
            v-else-if="tab_param && setbrandid && setbrandid === 'ADT'"
            :brand_slug="setbrandid"
            showTabs="flights"
            :activeTab="'flights'"
            :lang="lang"
            custom_class="dark-mobile"
            fetch_images="true"
            hide-tabs="true"
          />
          <SearchWidget
            v-else-if="tab_param && setbrandid == 'GSO'"
            :brand_slug="setbrandid"
            showTabs="parking"
            :activeTab="tab_param"
            :lang="lang"
            custom_class="dark-mobile"
            fetch_images="true"
          />
          <SearchWidget
            v-else-if="tab_param && setbrandid == 'BH2'"
            :brand_slug="setbrandid"
            showTabs="parking"
            :activeTab="tab_param"
            :lang="lang"
            custom_class="tabs-left large-strings dark-mobile alt-inputs"
            fetch_images="true"
            button-text="Get a Quote ➜"
          />
          <SearchWidget
            v-else-if="tab_param && setbrandid == 'RUN'"
            :brand_slug="setbrandid"
            showTabs="parking"
            :activeTab="tab_param"
            :lang="lang"
            custom_class="dark-mobile"
            fetch_images="true"
            :button-text="getrans('Find a space')"
          />
          <SearchWidget
            v-else-if="tab_param && setbrandid"
            :brand_slug="setbrandid"
            showTabs="parking, lounge, fasttrack, coach, travel, flights, holidays, hotels, tours, immigration, mapsearch"
            :activeTab="tab_param"
            :lang="lang"
            custom_class="dark-mobile"
            fetch_images="true"
          />
        </div>
      </div>

      <div class="hero-section-middle-split" v-if="hero_middle_split()">

        <div v-if="setbrandid == 'SB2'" class="hero-section-middle-split-grid">
          <!-- SB2 St. Pancras International - SB2 -->
          <div class="hero-section">
            <div class="hero-text">
              <h1>{{ getrans("WELCOME TO ST. PANCRAS INTERNATIONAL STATION") }}</h1>
              <p>{{ getrans("It’s good to see you today! Ready to make a booking?") }}</p>
            </div>
          </div>
          <div class="hero-image-container">
            <img
              class="hero-bg-desktop"
              :src="'https://res.cloudinary.com/rezcomm2018/image/upload/v1770388471/brands/SB2/SABA_hero_images/st-pancras-international-train-station-london-and-high-speed-eurostar-trains-2-1306x500.jpg'"
              alt="Hero Background"
            />
          </div>
        </div>

        <div v-else-if="setbrandid == 'SB3'" class="hero-section-middle-split-grid">
          <!-- SB3 Ashford International - SB3 -->
          <div class="hero-section">
            <div class="hero-text">
              <h1>{{ getrans("WELCOME TO ASHFORD INTERNATIONAL STATION") }}</h1>
              <p>{{ getrans("It’s good to see you today! Ready to make a booking?") }}</p>
            </div>
          </div>
            <div class="hero-image-container">
              <img
                class="hero-bg-desktop"
                :src="'https://res.cloudinary.com/rezcomm2018/image/upload/v1770388472/brands/SB2/SABA_hero_images/Ashford-International-1-1306x500.png'"
                alt="Hero Background"
              />
          </div>
        </div>

        <div v-else-if="setbrandid == 'SB4'" class="hero-section-middle-split-grid">
          <!-- SB4 Ebbsfleet International - SB4 -->
          <div class="hero-section">
            <div class="hero-text">
              <h1>{{ getrans("WELCOME TO EBBSFLEET INTERNATIONAL STATION") }}</h1>
              <p>{{ getrans("It’s good to see you today! Ready to make a booking?") }}</p>
            </div>
          </div>
          <div class="hero-image-container">
            <img
              class="hero-bg-desktop"
              :src="'https://res.cloudinary.com/rezcomm2018/image/upload/v1770388471/brands/SB2/SABA_hero_images/Ebbsfleet-International_022-scaled-1306x500.jpg'"
              alt="Hero Background"
            />
          </div>
        </div>


        <div v-else-if="setbrandid == 'SB5'" class="hero-section-middle-split-grid">
          <!-- SB5 Stratford International - SB5 -->
          <div class="hero-section">
             <div class="hero-text">
              <h1>{{ getrans("WELCOME TO STRATFORD INTERNATIONAL STATION") }}</h1>
              <p>{{ getrans("It’s good to see you today! Ready to make a booking?") }}</p>
            </div>
          </div>
          <div class="hero-image-container">
            <img
              class="hero-bg-desktop"
              :src="'https://res.cloudinary.com/rezcomm2018/image/upload/v1770391633/brands/SB2/SABA_hero_images/Stratford-International-1-1306x500.png'"
              alt="Hero Background"
            />
          </div>
        </div>


        <div v-else-if="setbrandid == 'GSO'" class="hero-section-middle-split-grid gso-easypark-hero">
          <div class="gso-easypark-hero-inner">
            <div class="gso-easypark-copy">
              <img
                class="gso-easypark-lockup"
                src="https://res.cloudinary.com/rezcomm2018/image/upload/v1789486003/brands/GSO/hero-split-images/pti-parking-meet-easypark-lockup.png"
                alt="Meet EasyPark. Now you can book your spot before you fly."
              />
            </div>
            <div class="gso-easypark-art">
              <img
                class="gso-easypark-logo"
                src="https://res.cloudinary.com/rezcomm2018/image/upload/v1789486003/brands/GSO/hero-split-images/EasyPark-hero-logo.png"
                alt="EasyPark"
              />
              <img
                class="gso-easypark-cars"
                src="https://res.cloudinary.com/rezcomm2018/image/upload/v1789486003/brands/GSO/hero-split-images/EasyPark-cars.png"
                alt="EasyPark parking options"
              />
            </div>
          </div>
        </div>

        <div v-else class="hero-section-middle-split-grid">
          <div class="hero-section">
            <div class="hero-text">
              <h1>{{ getrans(banner_heading) || "" }}</h1>
              <p>{{ getrans(banner_subheading) || "" }}</p>
            </div>
          </div>
          <div class="hero-image-container">
            <template v-for="hero in this.fetch_images" :key="hero">
              <img
                v-show="hero === this.hero_desktop_background"
                class="hero-bg-desktop"
                :src="hero"
                alt="Hero Background"
              />
            </template>
          </div>
        </div>
      </div>

      <div class="search-widget-below-hero" v-if="widget_below_hero()">
        <SearchWidget
          v-if="tab_param && setbrandid"
          :brand_slug="setbrandid"
          showTabs="parking, lounge, fasttrack, coach, travel, flights, holidays, hotels, tours, immigration, mapsearch"
          :activeTab="tab_param"
          :lang="lang"
          custom_class="dark-mobile"
          fetch_images="true"
        />
      </div>

      </template>
      <!-- this is live version -->
      <!-- <rez-occupency v-if="setbrandid == 'AIR'" style="display: block; width: 100%; font-size: 16px; max-width: 1280px; margin: 3rem auto;" brand-slug="HNL"></rez-occupency> -->

      <!-- <div style="text-align: center; padding-top: 10px">{{ resolution }}</div> -->
      <component
        :key="refresh_PanelsGroup"
        :is="PanelsGroup"
        v-cloak
        v-if="PanelsGroup && panels_group && lang && translations && setbrandid"
        :panels_group="panels_group"
        :lang="lang"
        :translations="translations"
        :getrans="getrans"
        :setbrandid="setbrandid"
      >
      </component>

      <!-- <v-other></v-other> -->

      <!-- <v-searchflights 
    custom-class="tabs-left large-strings dark-mobile alt-inputs" adults-select="1" children-select="0"
    infants-select="0" senior-select="0"
    show-tabs="flights" hide-tabs="false"
    active-tab="flights" brand-theme="light" brand-slug="BHX" button-text="Get a Quote ➜" custom-lang="en"
    use12h="false" results-domain="BHX"
      ></v-searchflights> -->

      <!-- {{faq_data}} -->

      <!-- {{ faqs_api_data }} -->

      <div class="faqs-section" 
        v-if="faq_homepage()"
        >
        <div class="left-section-wrapper">
          <div>
            <div class="big-question">
              <svg
                width="45"
                height="70"
                viewBox="0 0 9 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M2 4C2 4.5625 1.53125 5 1 5C0.4375 5 0 4.5625 0 4C0 1.8125 1.78125 0 4 0H5C7.1875 0 9 1.8125 9 4V4.125C9 5.5 8.28125 6.75 7.15625 7.5L5.84375 8.34375C5.625 8.46875 5.5 8.71875 5.5 8.96875V9C5.5 9.5625 5.03125 10 4.5 10C3.9375 10 3.5 9.5625 3.5 9V8.96875C3.5 8.03125 3.96875 7.15625 4.75 6.65625L6.0625 5.8125C6.625 5.4375 7 4.8125 7 4.125V4C7 2.90625 6.09375 2 5 2H4C2.875 2 2 2.90625 2 4ZM4.5 14C4.03125 14 3.625 13.7812 3.40625 13.375C3.1875 13 3.1875 12.5312 3.40625 12.125C3.625 11.75 4.03125 11.5 4.5 11.5C4.9375 11.5 5.34375 11.75 5.5625 12.125C5.78125 12.5312 5.78125 13 5.5625 13.375C5.34375 13.7812 4.9375 14 4.5 14Z"
                  fill="currentColor"
                />
              </svg>
            </div>
            <h2 class="big-question-text">Your questions, answered</h2>
            <div class="question-text">
              Don’t see your question here?<br />
              Explore the full
              <a href="/faqs">FAQs</a>
              for more details.
            </div>
          </div>
        </div>

        <div class="slide-togglers">
          <template
            v-for="faq_data in faqs_api_data"
            :key="faq_data.langauge_id"
          >
            <template
              v-if="lang.toUpperCase() === faq_data.langauge_code.toUpperCase()"
            >
              <div
                class="slide-toggler-wrapper"
                v-for="(category, cat_index) in faq_data.category"
                :key="category.category_id"
              >
                <template
                  v-for="(question_answer, index) in category.question_answer"
                  :key="question_answer.question"
                >
                  <div class="slide-toggler-border">
                    <h3 class="slide-toggler-heading">
                      <button
                        type="button"
                        class="slide-toggler"
                        :class="
                          question_answer.open ? 'slide-toggler-active' : ''
                        "
                        :aria-expanded="!!question_answer.open"
                        :aria-controls="'faq-home-a-' + cat_index + '-' + index"
                        @click="
                          [
                            !question_answer.open ? closeAllFaq() : null,
                            (question_answer.open = !question_answer.open),
                          ]
                        "
                      >
                        <span class="slide-toggler-text">
                          <span class="slide-toggler-question">{{ question_answer.question }}</span>
                        </span>
                        <i class="fas fa-chevron-right" aria-hidden="true"></i>
                      </button>
                    </h3>
                    <slide-up-down
                      v-model="question_answer.open"
                      :duration="200"
                    >
                      <div
                        class="faq-content"
                        :id="'faq-home-a-' + cat_index + '-' + index"
                        :aria-hidden="!question_answer.open"
                        :inert="question_answer.open ? null : ''"
                        v-html="question_answer.answer"
                      ></div>
                    </slide-up-down>
                  </div>
                </template>
              </div>
            </template>
          </template>
        </div>
      </div>

      <iframe
        v-if="setbrandid === 'IP1'"
        src="https://www.google.com/maps/embed?key=AIzaSyDMEwQL_NnDYpiw8MmOjtk-paNW6sdFer8&pb=!1m18!1m12!1m3!1d1119.4885961212276!2d-4.424163938017138!3d55.86306211975774!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x48884f1db3e3dfef%3A0x5d81f0fbe2160841!2siPark%20Glasgow!5e0!3m2!1sen!2suk!4v1655227726095!5m2!1sen!2suk"
        width="100%"
        height="300"
        style="border: 0"
        allowfullscreen=""
        loading="lazy"
        referrerpolicy="no-referrer-when-downgrade"
      >
      </iframe>
    </div>

    <!-- <pre>
  {{ brand_product_styles }}
  </pre> -->

    <Footerpit
      v-if="setbrandid === 'PIT'"
      :footer_links="footer_links"
      :footer_columns="footer_columns"
      :lang="lang.toUpperCase()"
      :translations="translations"
      :brandSlug="setbrandid"
    ></Footerpit>
    <Footer
      v-else
      :footer_links="footer_links"
      :footer_columns="footer_columns"
      :lang="lang.toUpperCase()"
      :translations="translations"
      :brandSlug="setbrandid"
    ></Footer>

    <!-- <LoginModel /> -->
    <BasketModel
      :lang="lang.toUpperCase()"
      :translations="translations"
      :brandSlug="setbrandid"
    ></BasketModel>

    <!-- <rez-ai v-if="setbrandid === 'HER'"></rez-ai> -->

    <rez-ai :brand-slug="setbrandid" v-if="setbrandid === 'PIT'"></rez-ai>

    <Cookies :brandSlug="setbrandid" :translations="translations" />
    <CookiesOld :brandSlug="setbrandid" v-if="setbrandid === 'none'" />
  </div>
</template>

<script>
const axios = require("axios");
const genkeys = require("rezauthlib");
var uap = require("ua-parser-js");
import { checkUserAuthStatus } from "@/utils/auth";
const { EncryptStorage } = require("encrypt-storage");
const encryptStorage = new EncryptStorage(process.env.VUE_APP_CHL, {
  storageType: "sessionStorage",
});
import Header from "../../components/Header.vue";
//import Header from "../../components/Header_tabs.vue";
import Footer from "../../components/Footer.vue";
import Footerpit from "../../components/FooterPIT.vue";
//import SearchWidget from "../../components/SearchWidget.vue";
//import SearchWidget from "../../components/SearchWidgetCustomElement.vue";
//import PanelsGroup from "../../components/PanelsGroup.vue";

import BasketModel from "../../components/BasketModel.vue";
const crypto = require("crypto");
//import Cookies from "../../components/Cookies.vue";
//const Cookies = () => import('../../components/Cookies.vue');

import { defineAsyncComponent } from "vue";
const Cookies = defineAsyncComponent(() =>
  import("../../components/Cookies.vue")
);
const CookiesOld = defineAsyncComponent(() =>
  import("../../components/Cookies_old.vue")
);
const SearchWidget = defineAsyncComponent(() =>
  import("../../components/SearchWidgetCustomElement.vue")
);

//import SearchWidget from "../../components/SearchWidgetCustomElement.vue";
//import PanelsGroup from "../../components/PanelsGroup.vue";

import jsSHA from "jssha";

//import { getCurrentBrowserFingerPrint } from "@rajesh896/broprint.js";
// import Basket from "../../components/Basket.vue";
// import LoginModel from "../../components/LoginModel.vue";
// import { cssData } from "../../modules/cssData";
// import FingerprintJS from "@fingerprintjs/fingerprintjs";
import { markRaw, reactive } from "vue";

import md5 from "js-md5";
const localforage = require("localforage");
let store = localforage.createInstance({
  name: "tranlations",
});

import { set_style_vars } from "@/modules/set_style_vars";
import RememberDeviceMixin from "@/mixins/RememberDeviceMixin.js";

export default {
  name: "App",
  mixins: [RememberDeviceMixin],
  components: {
    Header,
    Footer,
    Footerpit,
    SearchWidget,
    BasketModel,
    //LoginModel,
    Cookies,
    CookiesOld,
  },
  data() {
    return {
      multi_book: false,
      PanelsGroup: null,
      refresh_PanelsGroup: 0,
      updateHeader: 0,
      ua: {},
      styles_loaded: false,
      tab_param: "",
      lang: "en",
      translations: "",
      setbrandid: "",
      currency: "",
      brandloaded: false,
      widgetloaded: false,
      css_data: undefined,
      banner_heading: "",
      banner_subheading: "",
      brand_data: undefined,
      brand_data_key: 0,
      brand_product_styles: reactive({}),
      brand_product_settings: {},
      brand_products: {},
      hero_desktop_background: "",
      hero_mobile_background: "",
      logo_image: "",
      hero_font_size_h1: "3rem",
      hero_font_size_h1_mobile: "2rem",
      hero_font_size_p: "2rem",
      hero_font_size_p_mobile: "1rem",
      hero_text_align: "center",
      hero_text_align_mobile: undefined,
      use_local_data: false,
      header_menu: [],
      footer_links: [],
      logo_link: { mtype: "Internal", url: "/" },
      home_link: undefined,
      panels_background_color: "#d6d6d6",
      panels_group: undefined,
      panel_columns: 1,
      footer_columns: "1 Row",
      show_basket: false,
      fetch_images: [],
      fade_transition: "0.5",
      partner_id: "",
      partner_name: "",
      campaign_id: "",
      campaign_name: "",
      search_origin: "",
      utm_campaign_name: "",
      utm_partner: "",
      utm_medium: "",
      utm_content: "",
      utm_campaign: "",
      utm_source: "",
      utm_sub_partner: "",
      utm_term: "",
      resolution: "",
      loadingwebauthn: false,
      isAuthenticated: false,
      faqs_api_data: [],
      faq_data: false,
    };
  },
  computed: {
    new_style_variables() {
      return set_style_vars(this.brand_product_styles);
    },
    set_style_variables: function () {
      return {
        "--hero-background-mobile": `url(${this.hero_desktop_background})`,
        // "--hero-background-desktop": this.hero_mobile_background
        //   ? `url(${this.hero_mobile_background})`
        //   : `url(${this.hero_desktop_background})`,
        "--hero-font-size-h1": this.hero_font_size_h1,
        "--hero-font-size-h1-mobile": this.hero_font_size_h1_mobile,
        "--hero-font-size-p": this.hero_font_size_p,
        "--hero-font-size-p-mobile": this.hero_font_size_p_mobile,
        "--hero-text-align": this.hero_text_align,
        "--hero-text-align-mobile":
          this.hero_text_align_mobile || this.hero_text_align,
        "--panel-background-color": this.panels_background_color,
      };
    },
  },
  methods: {
    async get_PanelsGroup() {
      if (this.new_panels_view()) {
        const PanelsGroup_module = await import(
          "../../components/Panels_3.vue"
        );
        this.PanelsGroup = markRaw(PanelsGroup_module.default);
      } else {
        const PanelsGroup_module = await import(
          "../../components/PanelsGroup.vue"
        );
        this.PanelsGroup = markRaw(PanelsGroup_module.default);
      }

      this.refresh_PanelsGroup++;
    },
    faq_homepage() {
      if (
        process.env.VUE_APP_FAQ_HOMEPAGE &&
        JSON.parse(process.env.VUE_APP_FAQ_HOMEPAGE).includes(this.setbrandid)
      ) {
        return true;
      }
      return false;
    },
    widget_below_hero() {
      if (
        process.env.VUE_APP_INDEX_WIDGET_BELOW_HERO &&
        JSON.parse(process.env.VUE_APP_INDEX_WIDGET_BELOW_HERO).includes(
          this.setbrandid
        )
      ) {
        return true;
      }
      return false;
    },
    hero_middle_split() {
      if (
        process.env.VUE_APP_INDEX_HERO_MIDDLE_SPLIT &&
        JSON.parse(process.env.VUE_APP_INDEX_HERO_MIDDLE_SPLIT).includes(
          this.setbrandid
        )
      ) {
        return true;
      }
      return false;
    },
    new_panels_view() {
      if (
        process.env.VUE_APP_NEW_PANELS_VIEW &&
        JSON.parse(process.env.VUE_APP_NEW_PANELS_VIEW).includes(
          this.setbrandid
        )
      ) {
        return true;
      }
      return false;
    },
    setStyles(obj) {
      /* eslint-disable */
      if (!obj) return;
      obj.forEach((item) => {
        for (const [classname, style] of Object.entries(item)) {
          this.brand_product_styles[classname] = style;
        }
      });
      //console.log(this.brand_product_styles["asset_image_1"]);
      this.logo_image = this.brand_product_styles["asset_image_1"];
      // this.hero_font_size_h1 =
      //   this.brand_product_styles["panel_heading_font_size"];
      // this.hero_font_size_h1_mobile =
      //   this.brand_product_styles["panel_heading_font_size"];
      //console.log(this.hero_font_size_h1);
      // this.hero_font_size_p = this.brand_product_styles["panel_text_font_size"];
      this.hero_font_size_p_mobile =
        this.brand_product_styles["panel_text_font_size"];

      if (this.setbrandid === "NWI") {
        this.fade_transition = "0";
      }

      if (this.setbrandid === "FM1") {
        this.hero_text_align = "left";
      }

      /* eslint-enable */
    },

    getrans(string) {
      var s = md5(string);
      var ss = this.setbrandid + "-" + this.lang.toUpperCase() + "-" + s;
      //console.log(ss);
      return this.translations[ss] || string;
    },
    getSessionData(name) {
      return JSON.parse(sessionStorage.getItem(name));
    },
    setSessionData(name, value) {
      if (value != null) sessionStorage.setItem(name, JSON.stringify(value));
      else sessionStorage.removeItem(name);
    },
    loadTranslations() {
      let vm = this;
      if (vm.getSessionData("language")) {
        vm.lang = vm.getSessionData("language");
      } else {
        if (
          process.env.VUE_APP_DEFAULT_LANG_DE &&
          JSON.parse(process.env.VUE_APP_DEFAULT_LANG_DE).includes(
            this.setbrandid
          )
        ) {
          vm.lang = "de";
        }
        vm.setSessionData("language", vm.lang);
      }

      const urlParams = new URLSearchParams(window.location.search);
      let param_lang = urlParams.get("lang");
      if (param_lang) {
        vm.lang = param_lang;
        vm.setSessionData("language", vm.lang);
      }

      store.getItem("tranlations").then((params) => {
        if (params !== null) {
          vm.translations = JSON.parse(params);
          //console.log("getTranscache");
          //console.log(vm.translations);
        } else {
          let trans_url =
            process.env.VUE_APP_DOMAIN_DEVSSO +
            "brnd/brand/translations/parking?brandslug=";
          if (vm.setbrandid !== "HER") {
            trans_url =
              process.env.VUE_APP_DOMAIN_DEVSSO +
              "brnd/brand/translations?brandslug=";
          }

          axios.get(trans_url + vm.setbrandid).then((response) => {
            //console.log("getTranscache index");
            //console.log(response);
            vm.translations = response.data;
            store.setItem("tranlations", JSON.stringify(vm.translations));
          });
        }
      });
    },

    tab_change_action(hero_settings) {
      this.hero_desktop_background = hero_settings.hero_image;
      this.hero_mobile_background = hero_settings.hero_image;
      this.banner_heading = this.decodeQuotes(hero_settings.hero_heading);
      this.banner_subheading = this.decodeQuotes(
        hero_settings.hero_sub_heading
      );
    },

    decodeQuotes(str) {
      return str.replace(/&#39;/g, "'");
    },

    getLocalData(name) {
      return JSON.parse(sessionStorage.getItem(name));
    },
    setLocalData(name, value) {
      if (value != null) sessionStorage.setItem(name, JSON.stringify(value));
      else sessionStorage.removeItem(name);
    },
    setBrandData() {
      this.brand_data = this.getLocalData("brand_data");
      this.setStyles(this.brand_data.brand_product_styles);
      this.brand_product_settings = this.brand_data.brand_product_settings;
      this.brand_products = this.brand_data.brand_products;
      this.brand_data_key++;
      this.styles_loaded = true;
    },
    getBrandData() {
      if (this.use_local_data && this.getLocalData("brand_data")) {
        this.setBrandData();
      } else {
        axios
          .post(process.env.VUE_APP_DOMAIN_DEVSSO + "brnd/brand/details", {
            brandslug: this.setbrandid,
          })
          .then((response) => {
            //console.log("getBrandData", response.data);
            this.setLocalData("brand_data", response.data);
            this.setMenu(response.data);
            this.createPanels(response.data);
            this.setBrandData();
          });
      }
    },
    gensessionid() {
      if (encryptStorage.getItem("search_analytics_id") === undefined) {
        let search_analytics_id = crypto.randomBytes(16).toString("base64");
        encryptStorage.setItem("search_analytics_id", search_analytics_id);
        return search_analytics_id;
      } else {
        return encryptStorage.getItem("search_analytics_id");
      }
    },
    utmdata() {
      let sessid = "";
      let analytics = "0";
      if (!this.$cookie.isCookieAvailable("session-id")) {
        this.gensessionid();
        sessid = encryptStorage.getItem("search_analytics_id");
      } else {
        sessid = this.$cookie.getCookie("session-id");
        analytics = "1";
      }
      if (this.$cookie.isCookieAvailable("utm_partner")) {
        let trackevents = { page: window.location.href, analytics: analytics };
        let tdata = {
          utm_campaign: this.$cookie.getCookie("utm_campaign"),
          utm_content: this.$cookie.getCookie("utm_content"),
          utm_medium: this.$cookie.getCookie("utm_medium"),
          utm_partner: this.$cookie.getCookie("utm_partner"),
          utm_source: this.$cookie.getCookie("utm_source"),
          utm_sub_partner: this.$cookie.getCookie("utm_sub_partner"),
          utm_term: this.$cookie.getCookie("utm_term"),
          session_id: sessid,
          trackevents: trackevents,
        };

        let secsa = genkeys(
          process.env.VUE_APP_UTM_CAMPAIGN_SECRETID,
          process.env.VUE_APP_UTM_CAMPAIGN_SECRETKEY
        );
        let b1s = secsa.b1s;
        let v2s = secsa.v2s;
        let a1 = secsa.a1;
        let v1 = secsa.v1;
        let c2s = secsa.c2s;
        let uidgen = secsa.uidgen;

        axios
          .post(
            process.env.VUE_APP_DOMAIN_DEVHUB +
              "hubapmydbauth/utm_campaign/camp.php",
            tdata,
            {
              headers: {
                b1: b1s,
                v2: v2s,
                c2s: c2s,
                a1: a1,
                v1: v1,
                c1: uidgen,
                "Content-Type": "application/json",
              },
            }
          )
          .then((response) => {
            console.log("utmdata", response.data);
          });
      }
    },
    async getbranded() {
      await axios
        .post(process.env.VUE_APP_DOMAIN_DEVSSO + "brnd/brand/resolve", "")
        .then((response) => {
          // console.log("response.data.slug", response.data.slug);
          //console.log("response.data.currency", response.data.currency);
          if (response.data.code == "1") {
            this.setbrandid = response.data.slug;
            if (this.setbrandid == "AIR") {
              this.getResolution();
            }
            this.auto_remember_device();
            this.currency = response.data.currency;
            this.brandloaded = true;
            this.getBrandData();
            this.loadTranslations();

            this.get_srchana_iplatlon();
            this.getFaqs();
            this.get_PanelsGroup();
            if (this.setbrandid == "CP1") {
              this.multi_book = true;
            }
          }
        });
    },

    setMenu(data) {
      if (!Array.isArray(data.brand_menu) || !data.brand_menu.length > 0)
        return;
      data.brand_menu.forEach((menu) => {
        if (menu.label.toLowerCase() === "home") {
          this.home_link = menu.url;
        }
        if (menu.label.toLowerCase() === "logo") {
          this.logo_link = menu;
        }
        menu.loggedin = true;
        menu.loggedout = true;
      });

      const top_menu = data.brand_menu.filter((menu) => menu.position === "T");
      this.createHeaderLinks(top_menu);

      const footer_menu = data.brand_menu.filter(
        (menu) => menu.position === "B"
      );
      this.createFooterLinks(footer_menu);
    },
    createHeaderLinks(data) {
      const header_menu = [];
      if (data.length > 0) {
        data.forEach((menu) => {
          if (menu.label.toLowerCase() === "basket") {
            this.show_basket = true;
          } else if (
            menu.label.toLowerCase() !== "home" &&
            menu.label.toLowerCase() !== "logo"
          ) {
            header_menu.push(menu);
          }
        });
      }
      this.header_menu = header_menu;
    },
    createFooterLinks(data) {
      this.footer_columns = data[0].mcolumn;
      this.footer_links = data.reduce((a, r) => {
        if (!a[r.mgroup]) a[r.mgroup] = { group: r.mgroup, data: [] };
        a[r.mgroup].data.push(r);
        return a;
      }, {});
    },
    createPanels(data) {
      let panels_data = data.brand_home_panels || [];
      panels_data.sort((a, b) => (a.rownum > b.rownum ? 1 : -1));
      panels_data = panels_data.reduce((a, r) => {
        if (!a[r.rownum]) a[r.rownum] = { row: r.rownum, columns: [] };
        a[r.rownum].columns.push(r);
        a[r.rownum].columns.sort(function (a, b) {
          var keyA = Number(a.colnum),
            keyB = Number(b.colnum);
          // Compare the 2 dates
          if (keyA < keyB) return -1;
          if (keyA > keyB) return 1;
          return 0;
        });
        return a;
      }, {});
      this.panels_group = panels_data;
    },
    setTabFromParam() {
      // uses the url param to set the widget tab
      const urlParams = new URLSearchParams(window.location.search);
      let param_tab = urlParams.get("tab");
      if (param_tab) {
        this.tab_param = param_tab;
        switch (this.tab_param) {
          case "cpk":
            this.tab_param = "parking";
            break;
          case "expresslane":
          case "ftt":
            this.tab_param = "fasttrack";
            break;
          case "lounge":
          case "lng":
            this.tab_param = "lounge";
            break;
          case "seasonalparking":
            this.tab_param = "seasonalparking";
            break;
          default:
            this.tab_param = "parking";
            break;
        }
      } else {
        this.tab_param = "parking";
      }
    },

    toggle_basket_model() {
      const new_event = new CustomEvent("basket_model_toggle", {
        detail: {
          data: "toggle",
        },
      });
      window.dispatchEvent(new_event);
    },
    populateSensitiveUserData(value) {
      const shaObj = new jsSHA("SHA-256", "TEXT");
      shaObj.update(value);
      const hash = shaObj.getHash("HEX");

      return hash;
    },
    get_srchana_iplatlon() {
      let data = { brand_id: this.setbrandid };
      let secsaa = genkeys(
        process.env.VUE_APP_SRCHANA_SECRETID,
        process.env.VUE_APP_SRCHANA_SECRETKEY
      );
      let b1sa = secsaa.b1s;
      let v2sa = secsaa.v2s;
      let a1a = secsaa.a1;
      let v1a = secsaa.v1;
      let c2sa = secsaa.c2s;
      let uidgena = secsaa.uidgen;
      this.dataloaded = false;
      axios
        .post(process.env.VUE_APP_DOMAIN_LIVESSO + "srchana/iplatlon ", data, {
          headers: {
            b1: b1sa,
            v2: v2sa,
            c2s: c2sa,
            a1: a1a,
            v1: v1a,
            c1: uidgena,
            secret_id: process.env.VUE_APP_SRCHANA_SECRETID,
            secret_key: process.env.VUE_APP_SRCHANA_SECRETKEY,
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          this.dataloaded = true;
          let response_data = JSON.parse(response.request.response);
          if (response_data) {
            console.log("get_srchana_iplatlon", response_data);
            let anonymous = response_data.anonymous
              ? response_data.anonymous
              : "false";
            let proxy = response_data.proxy ? response_data.proxy : "false";
            let vpn = response_data.vpn ? response_data.vpn : "false";
            let tor = response_data.tor ? response_data.tor : "false";
            if (
              anonymous == "true" ||
              proxy == "true" ||
              vpn == "true" ||
              tor == "true"
            ) {
              //window.location.href='/proxycheck.html';
            }
          }
        });
    },

    getResolution() {
      // const realWidth = window.screen.width * window.devicePixelRatio;
      //const realHeight = window.screen.height * window.devicePixelRatio;
      const realWidth = window.screen.width;
      const realHeight = window.screen.height;
      this.resolution = `Your screen resolution is: ${realWidth} x ${realHeight}`;
    },
    ValidateEmail(mail) {
      var mailformat = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,6})+$/;
      if (mail.match(mailformat)) {
        return true;
      }
      return false;
    },
    async checkAuth() {
      this.loadingwebauthn = true;
      try {
        const authStatus = await checkUserAuthStatus(this.setbrandid);
        this.isAuthenticated = authStatus.isAuthenticated;
      } catch (error) {
        console.error("Auth check failed:", error);
        this.isAuthenticated = false;
      } finally {
        this.loadingwebauthn = false;
      }
    },
    sortBySortOrder(data) {
      return data.sort((a, b) => a.sort_order - b.sort_order);
    },
    sort_faq_order(faq) {
      return this.sortBySortOrder(faq);
    },
    closeAllFaq() {
      this.faqs_api_data.forEach((faq) => {
        if (faq.category && Array.isArray(faq.category)) {
          faq.category.forEach((cat) => {
            if (cat.question_answer && Array.isArray(cat.question_answer)) {
              cat.question_answer.forEach((qa) => {
                qa.open = false;
              });
            }
          });
        }
      });
    },
    getFaqs() {
      let brand = this.setbrandid;
      if (this.setbrandid == "BH1" || this.setbrandid == "BH2") {
        brand = "BHX";
      }
      axios
        .post(
          `https://api.rezcomm.com/faq/frontend/question/answer/list`,
          {
            brand_id: brand,
            category_type: "I",
          },
          {
            headers: {
              secret_id: `4e09f6ee78e00f8615dfcbe2ddd42176`,
              secret_key: `4eac7bdab6dd4598f20b91653a7fe92f35367f91985a6fea6c2eb811cbd16353`,
              "Content-Type": "application/json",
            },
          }
        )
        .then((response) => {
          console.log(response);
          let faqs_api_data = response.data.data;
          // add open property to each faq item
          faqs_api_data.forEach((faq) => {
            faq.open = false;
          });
          this.faqs_api_data = this.sort_faq_order(faqs_api_data);
        });
    },
  },
  created() {},
  mounted() {
    // Remove the loader once Vue is initialized
    const loader = document.getElementById("loader");
    if (loader) {
      loader.parentNode.removeChild(loader);
    }

    const yourEmailSha256Variable = this.populateSensitiveUserData(
      "test@yourdomain.com"
    );
    console.log("yourEmailSha256Variable", yourEmailSha256Variable);
    this.getbranded();

    var ua = uap(navigator.userAgent);
    this.ua = ua;
    // let pa = ua.getResult();
    encryptStorage.setItem("uas", this.ua);
    console.log("ua", encryptStorage.getItem("uas"));
    // console.log('pa',pa);
    var hours = 1 / 2;
    var noww = new Date().getTime();
    var snddc = sessionStorage.getItem("snddc");
    if (snddc == null) {
      sessionStorage.setItem("snddc", noww);
    } else {
      if (noww - snddc > hours * 60 * 60 * 1000) {
        sessionStorage.clear();
        sessionStorage.setItem("snddc", noww);
      }
    }
    setTimeout(() => {
      this.widgetloaded = true;
      //sessionStorage.clear();
    }, 0);

    this.setTabFromParam();
    const urlParams = new URLSearchParams(window.location.search);
    console.log("urlParams", urlParams);
    if (urlParams.has("utm_partner")) {
      this.utm_partner = urlParams.get("utm_partner");
    }
    if (urlParams.has("utm_medium")) {
      this.utm_medium = urlParams.get("utm_medium");
    }
    if (urlParams.has("utm_content")) {
      this.utm_content = urlParams.get("utm_content");
    }
    if (urlParams.has("utm_campaign")) {
      this.utm_campaign = urlParams.get("utm_campaign");
    }
    if (urlParams.has("utm_campaign_name")) {
      this.utm_campaign_name = urlParams.get("utm_campaign_name");
    }
    if (urlParams.has("utm_source")) {
      this.utm_source = urlParams.get("utm_source");
    }
    if (urlParams.has("utm_sub_partner")) {
      this.utm_sub_partner = urlParams.get("utm_sub_partner");
    }
    if (urlParams.has("utm_term")) {
      this.utm_term = urlParams.get("utm_term");
    }
    if (urlParams.has("search_origin")) {
      this.search_origin = urlParams.get("search_origin");
    }

    if (!this.$cookie.isCookieAvailable("utm_partner")) {
      this.$cookie.setCookie("utm_partner", this.utm_partner);
    } else {
      this.$cookie.setCookie("utm_partner", this.utm_partner);
    }
    if (!this.$cookie.isCookieAvailable("utm_medium")) {
      this.$cookie.setCookie("utm_medium", this.utm_medium);
    } else {
      this.$cookie.setCookie("utm_medium", this.utm_medium);
    }
    if (!this.$cookie.isCookieAvailable("utm_content")) {
      this.$cookie.setCookie("utm_content", this.utm_content);
    } else {
      this.$cookie.setCookie("utm_content", this.utm_content);
    }
    if (!this.$cookie.isCookieAvailable("utm_campaign")) {
      this.$cookie.setCookie("utm_campaign", this.utm_campaign);
    } else {
      this.$cookie.setCookie("utm_campaign", this.utm_campaign);
    }
    if (!this.$cookie.isCookieAvailable("utm_campaign_name")) {
      this.$cookie.setCookie("utm_campaign_name", this.utm_campaign_name);
    } else {
      this.$cookie.setCookie("utm_campaign_name", this.utm_campaign_name);
    }
    if (!this.$cookie.isCookieAvailable("utm_source")) {
      this.$cookie.setCookie("utm_source", this.utm_source);
    } else {
      this.$cookie.setCookie("utm_source", this.utm_source);
    }
    if (!this.$cookie.isCookieAvailable("utm_sub_partner")) {
      this.$cookie.setCookie("utm_sub_partner", this.utm_sub_partner);
    } else {
      this.$cookie.setCookie("utm_sub_partner", this.utm_sub_partner);
    }
    if (!this.$cookie.isCookieAvailable("utm_term")) {
      this.$cookie.setCookie("utm_term", this.utm_term);
    } else {
      this.$cookie.setCookie("utm_term", this.utm_term);
    }

    // when getting css api data
    // this.css_data = cssData;

    // const fpPromise = FingerprintJS.load();
    // (async () => {
    //   const fp = await fpPromise;
    //   const result = await fp.get();
    //   const visitorId = result.visitorId;
    //   this.$cookie.setCookie("_vis_fin_id", visitorId, {
    //     expire: 4320 * 60 * 60,
    //   });
    // })();

    window.addEventListener(
      "tabChanged",
      (event) => {
        //console.log("tabChanged event", event.detail);
        this.tab_change_action(event.detail);
      },
      false
    );
    window.addEventListener(
      "tabFetchData",
      (event) => {
        console.log(event.detail);
        if (
          event &&
          event.detail &&
          event.detail.hero_image &&
          this.fetch_images.indexOf(event.detail.hero_image) === -1
        ) {
          this.fetch_images.push(event.detail.hero_image);
        }
      },
      false
    );

    window.addEventListener(
      "search_results_button_click",
      (event) => {
        encryptStorage.setItem("search_results_button_click", "1");
        console.log("search_results_button_click got it", event.detail.data);
      },
      false
    );

    setTimeout(() => {
      // BH2: If partner isn't set, force to Jet2
      if (this.setbrandid === "BH2") {
        if (!this.$cookie.isCookieAvailable("partner_id")) {
          this.$cookie.setCookie("partner_id", 36);
          this.$cookie.setCookie("partner_name", "Jet2 Referral");
          setTimeout(() => {
            this.gotoPage("/index.html");
          }, 500);
        }
      }
       if (this.setbrandid === "BH3") {
        if (!this.$cookie.isCookieAvailable("partner_id")) {
          this.$cookie.setCookie("partner_id", 36);
          this.$cookie.setCookie("partner_name", "Jet2 Referral");
          setTimeout(() => {
            this.gotoPage("/index.html");
          }, 500);
        }
      }

      this.utmdata();
    }, 500);
  },
};
</script>

<style lang="scss">
@import "@/assets/sass/normalise.scss";
@import "@/assets/sass/bodyStyle.scss";
@import "@/assets/sass/calenderOverride.scss";
@import "@/assets/sass/override_brand.scss";
@import "@/assets/sass/swalOverride.scss";
// .tab-basket {
//   display: none !important;
// }
</style>

<style scoped lang="scss">
[v-cloak] {
  display: none;
}

@import "@/assets/sass/variables.scss";

.hero-section {
  height: auto;
  min-height: 350px;
  background: $indexpage-hero-bg;

  .hero-bg-mobile {
    min-height: 210px;
    @media screen and (max-width: 767px) {
      background: linear-gradient(
          0deg,
          var(--hero_overlay, #00000033),
          var(--hero_overlay, #00000033)
        ),
        var(--hero-background-mobile);
      background-size: cover;
      height: auto;
      position: relative;
      width: 100%;
      z-index: 0;
      transition: background-image 0.5s ease-in-out;
    }
  }

  .hero-bg-desktop {
    @media screen and (min-width: 768px) {
      // background: linear-gradient(
      //     0deg,
      //     var(--hero_overlay, #00000033),
      //     var(--hero_overlay, #00000033)
      //   ),
      //   var(--hero-background-desktop);
      // background-size: cover;
      // background-repeat: no-repeat;
      // background-position-x: center;
      // background-position-y: center;
      // background-attachment: fixed;
      background-repeat: no-repeat;
      background-size: 100% auto;
      background-attachment: var(--hero_position, fixed);
      background-position-y: var(--hero_position_y, top);
      background-position-x: center;

      max-height: $indexpage-hero-height;
      height: 100%;
      position: absolute;
      width: 100%;
      z-index: 0;
      transition: background-image 0.5s ease-in-out;
    }
  }

  .hero-overlay {
    transition: 0ms;
    background: linear-gradient(
      0deg,
      var(--hero_overlay, #00000033),
      var(--hero_overlay, #00000033)
    );
    max-height: 300px;
    height: 100%;
    position: absolute;
    width: 100%;
    z-index: 0;
  }

  .hero-text {
    position: relative;
    margin: 0 auto;
    max-width: 1260px;
    text-align: var(--hero-text-align-mobile);
    padding: 15px 15px;
    box-sizing: border-box;
    color: $indexpage-hero-text;
    text-shadow: $indexpage-hero-text-shadow;

    @media screen and (min-width: 768px) {
      text-align: var(--hero-text-align);
    }

    h1 {
      font-family: $indexpage-hero-font-h1;
      font-size: var(--hero-font-size-h1-mobile);

      @media screen and (min-width: 768px) {
        font-size: var(--hero-font-size-h1);
      }
    }

    p {
      font-family: $indexpage-hero-font-p;
      font-size: var(--hero-font-size-p-mobile);

      @media screen and (min-width: 768px) {
        font-size: var(--hero-font-size-p);
      }
    }

    h1,
    p {
      margin: 10px 0px;

      @media screen and (min-width: 768px) {
        margin: 10px;
      }
    }

    @media screen and (min-width: 768px) {
      padding: 2.5rem 2rem;
    }
  }
}

.HER .hero-bg-desktop {
  @media screen and (min-width: 768px) {
    background-position-y: 100%;
  }
}

.SZG .hero-text {
  h1 {
    text-align: left;
  }
  p {
    text-align: left;
    font-size: 1.3rem;
  }
}

.search-widget-desktop {
  max-width: 1280px;
  margin: 0 auto;
  min-height: 142px;
  .search-widget {
    min-height: 142px;
  }
}

.hero-bg-desktop.hero-bg-desktop-fade {
  transition: opacity 0.5s ease;
}

.subheading-alt {
  font-size: 1.5rem;
}

.SV1 .hero-section,
.SV1 .page-bg {
  background: whitesmoke;
}

.PITBorder {
  position: absolute;
  width: 10px;
  height: 60%;
  background: transparent;
  border-left: 4px solid #fff;
  margin: 1rem 0;
}

.faqs-section .slide-toggler-wrapper {
  .slide-toggler-heading {
    margin: 0;
    padding: 0;
    font-size: inherit;
    font-weight: inherit;
    line-height: inherit;
  }
  .slide-toggler {
    width: 100%;
    padding: 1rem;
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    align-items: center;
    user-select: none;
    background: none;
    border: none;
    font: inherit;
    color: inherit;
    text-align: left;
    i {
      transition: 0.2s ease-in-out;
      transform: rotate(0deg);
    }
    .slide-toggler-text {
      display: flex;
      align-items: center;
      flex-direction: column;
      align-items: flex-start;
      justify-content: flex-start;
      gap: 0.25rem;
      text-align: left;
      * {
        margin: 0;
        padding: 0;
        font-size: 0.8rem;
        font-family: var(--details_headings_font_family, inherit);
      }
      .slide-toggler-question {
        font-weight: var(--details_headings_font_weight, bold);
        color: var(--details_headings_font_color, #0a3b74);
        font-size: var(--details_headings_font_size, 1.25rem);
      }
    }
  }
  .slide-toggler.slide-toggler-active {
    i {
      transform: rotate(90deg);
    }
  }
}

.faqs-section {
  margin: 4rem auto;
  max-width: calc(1280px + 2rem);
  padding: 1rem;
  display: flex;
  gap: 1rem;
  flex-direction: row;
  @media screen and (max-width: 767px) {
    flex-direction: column;
  }
  justify-content: center;
  align-items: center;
  .left-section-wrapper {
    flex: 1;
  }

  .slide-toggler-border {
    border-radius: 0.5rem;
    border: 1px solid #ddd;
    border-radius: 0.5rem;
    box-shadow: 0 3px 6px rgb(0 0 0 / 16%) !important;
    margin-block: 0.5rem;
  }

  .slide-togglers {
    width: 100%;
    flex: 2;
  }

  .left-section-wrapper {
    text-align: center;
    .big-question {
      font-size: 6rem;
    }
    .big-question-text {
      margin: 0 0 1rem 0;
      font-size: 1.5rem;
    }
    .question-text {
      margin-bottom: 0.5rem;
      a {
        text-decoration: underline;
        color: $page-links;
      }
    }
  }
}

.faq-content {
  padding: 1px 1rem 1px;
}

.search-widget-below-hero {
  position: relative;
  padding: 1rem;
  background: #fff;
  .search-widget {
    max-width: 1280px;
    margin: 0 auto;
    position: relative;
  }
}

.hero-section-middle-split {

.hero-section-middle-split-grid {
  display: grid;
  grid-template-columns: 50% 50%;
  align-items: center;
  height: auto;
  width: 100%;

  @media screen and (max-width: 767px) {
    grid-template-columns: 1fr;
    text-align: center;
  }

  .hero-section {
    display: flex;
    justify-content: flex-start;
    /* flex-direction: column; */
    align-items: center;
    min-height: 100%;
  }

  .hero-text {
    padding: 2rem;
    max-width: 640px;
    width: 100%;
    margin-left: auto;
    margin-right: 0;
    text-align: left;
    * {
      text-align: left !important;
    }
  }

  .hero-image-container {
    width: 100%;
    text-align: left;

    img {
      width: auto;
      height: 100%;
      margin-left: 0;
      margin-right: auto;
      max-height: 400px;
      @media screen and (max-width: 767px) {
        width: 100%;
        height: auto;
      }
    }
  }
}

}

.hero-section-middle-split .hero-section-middle-split-grid.gso-easypark-hero {
  width: 100%;
  min-height: 310px;
  overflow: hidden;
  background: #1d385f;
  display: block;
  grid-template-columns: none;
  grid-template-rows: none;
}

.gso-easypark-hero-inner {
  width: 100%;
  max-width: 1280px;
  min-height: 310px;
  margin: 0 auto;
  padding: 0 32px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 32px;
  align-items: stretch;
  box-sizing: border-box;

  .gso-easypark-copy,
  .gso-easypark-art {
    display: block;
  }

  .gso-easypark-copy {
    display: flex;
    align-items: center;
  }

  .gso-easypark-lockup {
    display: block;
    width: min(100%, 480px);
    height: auto;
  }

  .gso-easypark-art {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    justify-content: space-between;
    padding: 32px 0 0;
    box-sizing: border-box;
  }

  .gso-easypark-logo {
    display: block;
    width: min(100%, 225px);
    height: auto;
  }

  .gso-easypark-cars {
    display: block;
    width: min(100%, 220px);
    height: auto;
  }

  @media screen and (max-width: 767px) {
    min-height: 400px;
    display: flex;
    flex-direction: column;
    gap: 0;
    padding: 24px 16px 0;

    .gso-easypark-copy {
      flex: 0 0 auto;
      justify-content: center;
    }

    .gso-easypark-art {
      flex: 1 1 auto;
      width: 100%;
      align-items: center;
      padding: 0;
    }

    .gso-easypark-lockup {
      width: min(100%, 320px);
    }

    .gso-easypark-logo {
      width: min(100%, 260px);
    }

    .gso-easypark-cars {
      width: min(100%, 260px);
    }
  }
}

.hero-widget-container {
  margin: 2rem auto 2rem 0;
  max-width: 1280px;
  padding: 0 1rem;
  width: 100%;
  .search-widget {
    max-width: 620px;
    margin: 0;
  }
}
</style>
